import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 48 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", { d: "M22.897 0h-9.944L5.88 9.93l7.317-.025-4.14 2.079L0 40h9.902zM23.656 9.905H44.78L48 0H26.874zM18.773 24.948h10.562l3.21-9.896H21.994z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", { d: "M0 0h48v40H0z" })
      ])
    ], -1)
  ])))
}
export default { render: render }